"use client"
import {observer} from "mobx-react";
import styled from "styled-components";
import {useEffect} from "react";
import {SIZES} from "@/components/constants";
import {useStore} from "@/store";
import {usePathname, useRouter, useSearchParams} from "next/navigation";
import DownLoadIcon from "/public/assets/icons/gray-down-ico.png"
import moment from "moment-timezone";
import {downloadFile} from "@/utils";
import Button from "@/components/common/Button";
import EditorLinkIcon from "/public/assets/icons/editor-link.svg"
import "ckeditor5/ckeditor5.css";
import "@/styles/ckeditor-content.css";
import {useMediaQuery} from "react-responsive";

const BoardDetailPage = observer(() => {
    const isTablet = useMediaQuery({
        query: `(max-width: ${SIZES.TABLET})`
    });
    const {navigationStore, contentStore} = useStore();
    const searchParams = useSearchParams();
    const menuId = searchParams.get("menu-id");
    const contentId = searchParams.get("content-id");
    const contentType = searchParams.get("content-type");
    const pathname = usePathname();
    const router = useRouter();
    useEffect(() => {
        contentStore.setMenuContent(navigationStore.navigateList, menuId, undefined, contentId).then();
    }, [menuId, contentId]);
    useEffect(() => {
        return() => {
            contentStore.setClearBoardDetail()
        }
    }, []);
    return(
        <BoardDetailPageWrap>
            {
                contentStore.boardDetailData &&
                <>
                    <div className={"detail-content-wrap"}>
                        <div className={"detail-content-top-wrap"}>
                            {
                                !isTablet &&
                                <div className={"detail_summary-wrap"}>
                                    <div className={"cont-cate"}>
                                        <span>{contentStore.boardDetailData.data.classification}</span>
                                    </div>
                                </div>
                            }
                            <div className={"button-area"}>
                                <Button
                                    type="solid"
                                    size="m"
                                    text="목록"
                                    round={true}
                                    styling={"gray"}
                                    onClickFunc={async () => {

                                        if (contentType) {
                                            let url = contentType;
                                            if(contentType !== "news"){
                                                url = `board/${contentType}`;
                                            }
                                            router.push(`/homepage/${url}?menu-id=${menuId}`)
                                        }
                                    }}
                                />
                            </div>
                        </div>
                        <div className={"detail-desc"}>
                            <div className={"detail-desc-wrapper"}>
                                <div className={"desc-inner"}>
                                    {
                                        !isTablet &&
                                        <div className={"desc-item"}>
                                            <div className={"title"}>분류</div>
                                            <div className={"desc"}>{contentStore.boardDetailData.data.classification}</div>
                                        </div>
                                    }
                                    {
                                        !isTablet &&
                                        <div className={"desc-item"}>
                                            <div className={"title"}>제목</div>
                                            <div className={"desc"}>{contentStore.boardDetailData.data.title}</div>
                                        </div>
                                    }
                                </div>
                                <div className={"desc-inner"}>
                                    {
                                        contentStore.boardDetailData.data.startDate && contentStore.boardDetailData.data.endDate &&

                                        <div className={"desc-item"}>
                                            <div className={"title"}>기간</div>
                                            <div className={"desc"}>
                                                {contentStore.boardDetailData.data.startDate} ~ {contentStore.boardDetailData.data.endDate}
                                            </div>
                                        </div>
                                    }
                                    <div className={"desc-item"}>
                                        <div className={"title"}>작성일</div>
                                        <div
                                            className={"desc"}>{moment(contentStore.boardDetailData.updatedAt).tz("Asia/Seoul").format("YYYY-MM-DD")}</div>
                                    </div>
                                </div>
                            </div>

                            {
                                contentType === "news" && contentStore.boardDetailData.data.link &&
                                <div className={"desc-item only"}>
                                    <div className={"title"}>출처 링크</div>
                                    <div
                                        className={"desc"}>{contentStore.boardDetailData.data.link}</div>
                                </div>
                            }


                        </div>
                        {
                            isTablet &&
                            <div className={"desc-title"}>
                                <div className={"desc-title-inner"}>{contentStore.boardDetailData.data.title}</div>
                            </div>
                        }
                        <div className="detail-cont">
                            <div
                                className="ck-editor-content ck-content"
                                dangerouslySetInnerHTML={{__html: contentStore.boardDetailData.data.listContent || ""}}
                            />
                        </div>
                        {
                            contentStore.boardDetailData.data.files && contentStore.boardDetailData.data.files.length > 0 &&
                            <div className={"detail-file"}>
                                <div className={"file-title"}>첨부파일</div>
                                <div className={"file-inner"}>
                                    {
                                        contentStore.boardDetailData.data.files.map((item, key) =>
                                            <div className={"file-item"} key={key}
                                                 onClick={() => downloadFile(item.path, item.name)}>
                                                <div className={"icon-wrap"}>
                                                    <img src={DownLoadIcon?.src} alt={"다운로드 아이콘"}/>
                                                </div>
                                                {item.name}
                                            </div>
                                        )
                                    }
                                </div>
                            </div>
                        }

                        {/*<div className={"back-list"}>목록</div>*/}
                    </div>
                    <div className={"page-btn-wrap"}>
                        {
                            contentStore.boardDetailPrevData && contentStore.boardDetailPrevData.menuId === contentStore.boardDetailData.menuId &&
                            (
                                (contentType === "news" && contentStore.boardDetailPrevData.type === "E-NEWS") ||
                                (contentType !== "news" && contentStore.boardDetailPrevData.subType?.toLowerCase() === contentType)
                            ) && (
                                <Button
                                    type="solid"
                                    size={!isTablet ? "l" : "m"}
                                    text="이전글 보기"
                                    brand={true}
                                    onClickFunc={async () => {
                                        router.push(
                                            `/homepage/management/detail?menu-id=${contentStore.boardDetailPrevData.menuId}&content-id=${contentStore.boardDetailPrevData._id}&content-type=${contentType}`,
                                        );
                                    }}
                                />
                            )
                        }
                        {
                            contentStore.boardDetailNextData && contentStore.boardDetailNextData.menuId === contentStore.boardDetailData.menuId &&
                            (
                                (contentType === "news" && contentStore.boardDetailNextData.type === "E-NEWS") ||
                                (contentType !== "news" && contentStore.boardDetailNextData.subType?.toLowerCase() === contentType)
                            ) && (
                                <Button
                                    type="solid"
                                    size={!isTablet ? "l" : "m"}
                                    text="다음글 보기"
                                    brand={true}
                                    onClickFunc={async () => {
                                        router.push(
                                            `/homepage/management/detail?menu-id=${contentStore.boardDetailNextData.menuId}&content-id=${contentStore.boardDetailNextData._id}&content-type=${contentType}`
                                        );
                                    }}
                                />
                            )
                        }

                    </div>
                </>
            }
        </BoardDetailPageWrap>
    )
});
const BoardDetailPageWrap = styled.div`
    padding: 40px 0 260px;

    .detail-content-wrap {
        max-width: 1280px;
        margin: 0 auto;
        position: relative;

        .detail-content-top-wrap{
            width: 100%;
            height: 52px;
            border-bottom: 1px solid #DEDCEC;
            display: flex;
            align-items: center;
            position: relative;
            .button-area{
                position: absolute;
                top: 0;
                right: 0;
            }
            .detail_summary-wrap {
                display: flex;
                align-items: center;
                gap: 20px;

                .cont-number {
                    display: flex;
                    align-items: center;
                    gap: 4px;
                }

                .cont-cate {
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    padding: 0 8px;
                    height: 22px;
                    background: #F2F2F2;
                    border-radius: 99px;
                    span{
                        font-weight: 700;
                        font-size: 12px;
                        line-height: 18px;
                        color: #38304D;
                    }
                }
                p {
                    font-weight: 400;
                    font-size: 14px;
                    line-height: 22px;
                    color: #564F67;
                }

                span {
                    font-weight: 700;
                    font-size: 14px;
                    line-height: 22px;
                    color: #38304D;
                }
            }
        }
        
        .back-list {
            position: absolute;
            top: -16px;
            right: 0;
            display: flex;
            justify-content: center;
            align-items: center;
            width: 57px;
            height: 36px;
            border: 1px solid #CCCCCC;
            border-radius: 4px;
            font-weight: 600;
            font-size: 14px;
            letter-spacing: 0.02em;
            color: #564F67;
            cursor: pointer;
        }

        

        .detail-desc {
            padding: 16px 0;
            border-bottom: 1px solid #DEDCEC;
            .detail-desc-wrapper{
                display: flex;
            }
        }

        .desc-inner {
            width: 50%;
            display: flex;
            flex-direction: column;
            gap: 8px;
            padding: 0 24px;
        }
        .desc-item {
            display: flex;
            //align-items: center;

            .title {
                width: 144px;
                font-weight: 700;
                font-size: 14px;
                line-height: 18px;
                color: #999999;
                flex-shrink: 0;
            }

            .desc {
                font-weight: 400;
                font-size: 14px;
                line-height: 18px;
                color: #38304D;
            }
            &.only{
                margin-top: 8px;
                //padding: 0 24px;
            }
        }

        .detail-cont {
            border-bottom: 1px solid #DEDCEC;
            padding: 40px 24px;
            font-weight: 400;
            font-size: 16px;
            line-height: 20px;
            color: #333333;
            .ck-editor-content img {
                max-width: 100%;
                width: auto;
                height: auto;
            }
            .ck-editor-content .image{
                max-width: 100%;
                width: auto;
                height: auto;
                margin: 0;
            }
            .ck-editor-content .image > a{
                position: relative;
                &::before{
                    content: "";
                    position: absolute;
                    top: 8px;
                    right: 8px;
                    background-image: url(${EditorLinkIcon?.src});
                    background-repeat: no-repeat;
                    background-size: cover;
                    width: 20px;
                    height: 20px;
                    //EditorLinkIcon
                }
            }
            .ck-editor-content .table:not(.layout-table) {
                margin: 0;
            }
        }

        .detail-file {
            border-bottom: 1px solid #DEDCEC;
            padding: 14px 0;
            display: flex;

            .file-title {
                padding: 0 24px;
                display: flex;
                align-items: center;
                font-size: 14px;
                font-weight: 700;
                line-height: 18px;
            }
            .file-inner{
                padding: 0 24px;
                display: flex;
                align-items: center;
                flex-wrap: wrap;
                gap: 12px;
                .file-item{
                    display: flex;
                    align-items: center;
                    gap: 12px;
                    justify-content: center;
                    padding: 0 20px;
                    height: 44px;
                    background: #FFFFFF;
                    border: 1px solid #CCCCCC;
                    border-radius: 99px;
                    cursor: pointer;
                    .icon-wrap{
                        width: 16px;
                    }
                }
            }
        }
    }
    .page-btn-wrap{
        margin-top: 40px;
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 16px;
        .page-btn{
            width: 115px;
            height: 44px;
            display: flex;
            align-items: center;
            justify-content: center;
            background: #FFFFFF;
            border: 1px solid #4939B1;
            font-weight: 600;
            font-size: 16px;
            line-height: 20px;
            letter-spacing: 0.02em;
            color: #4939B1;
            cursor: pointer;
        }
    }
    @media (max-width: ${SIZES.TABLET}) {
        padding: 40px 16px 160px;
        .detail-content-wrap{
            max-width: 100%;
            width: 100%;
            .detail-content-top-wrap{
                .detail_summary-wrap{
                    display: none;
                }
            }
            .desc-title{
                padding: 16px 24px;
                border-bottom: 1px solid #DEDCEC;
                .desc-title-inner{
                    font-weight: 700;
                    font-size: 14px;
                    line-height: 22px;
                    color: #38304D;
                }
            }
            .detail-desc{
                display: block;
                padding: 16px 24px;
                .detail-desc-wrapper {
                    display: block;
                }
            }
            .desc-inner{
                width: 100%;
                padding: 0;
                & + .desc-inner{
                    margin-top: 8px;
                }
            }
            .desc-item{
                .title{
                    width: 100px;
                    font-weight: 700;
                    font-size: 12px;
                    line-height: 14px;
                    color: #999999;
                    flex-shrink: 0;
                }
                .desc{
                    flex: 1;
                    min-width: 0;
                    font-weight: 400;
                    font-size: 14px;
                    line-height: 18px;
                    color: #38304D;
                }
            }
            .detail-cont{
                font-weight: 400;
                font-size: 14px;
                line-height: 18px
            }
            .detail-file{
                .file-title{
                    align-items: start;
                    padding: 16px 24px;
                }
                .file-inner{
                    display: block;
                    .file-item{
                        & + .file-item{
                            margin-top: 12px;
                        }
                    }
                }
            }
        }
        .page-btn-wrap{
            margin-top: 72px;
        }
    }
`
export default BoardDetailPage